import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'fgb-marketplace-wallet-page',
  templateUrl: './marketplace-wallet-page.component.html',
  styleUrls: ['./marketplace-wallet-page.component.scss'],
})
export class MarketplaceWalletPageComponent implements OnInit {
  constructor(private route: ActivatedRoute) {}
  id: number;
  ngOnInit() {
    this.id = +(this.route.snapshot.paramMap.get('id') || 0);
  }
}
